module.exports = __webpack_public_path__ + "img/counsel_intro_list_text.469eeaa4.png";